import io, { Socket } from 'socket.io-client';
import { HandlersCollection } from '@tblabs/truffle';
import { AppConfigProvider } from './AppConfigProvider';
import { ConnectionStatusEvent } from './ConnectionStatusEvent';
import { IServer } from './IServer';
import { ClientInfoProvider } from './Storage/ClientInfoProvider';


export class Server implements IServer
{
    public Socket: Socket;
    public IsConnected: boolean = false;
    public OnConnectionChange = new HandlersCollection<(event: ConnectionStatusEvent) => void>();

    constructor(private _config: AppConfigProvider, private _clientInfo: ClientInfoProvider)
    { }

    private Log(...msg): void
    {
        // console.log('[Server]', ...msg);
    }

    public get ServerId(): string
    {
        return this._config.ServerId.value;
    }

    private SetConnectionStatus(isConnected: boolean, problem?: string): void
    {
        this.IsConnected = isConnected;
        const event = new ConnectionStatusEvent(this.IsConnected, problem);

        this.OnConnectionChange.Call(event);
    }

    public Init(): void
    {
        this.Log(`Server initialization (${this._config.ServerInfo.Addr} / "${this._config.Password}")...`);

        const handshake = {
            who: "watcher",
            password: this._config.Password,
            id: this._clientInfo.ClientId,
            info: this._clientInfo.ClientInfo,
            adminToken: this._config.AdminToken
        };
        
        this.Socket = io(this._config.ServerInfo.Addr, {
            autoConnect: false,
            query: handshake
        });

        this.Socket
            .on('connect', () =>
            {
                this.Log(`Connected using socket to ${this._config.ServerInfo.Addr}.`);
                this.SetConnectionStatus(true);
            })
            .on('connect_error', (err) =>
            {
                // Webrowser throttling is set to Offline - TODO: IS IT THE SAME AS NO INTERNET? CHECK THAT!
                // "ERR_INTERNET_DISCONNECTED"
                // Server is offline
                // if (err.message == "ERR_CONNECTION_REFUSED")
                this.Log(`Socket connection error:`, err.message);
                this.SetConnectionStatus(false, err.message);
            })
            .on('disconnect', (reason: string) =>
            {
                this.Log(`Socket disconnected.`);

                this.SetConnectionStatus(false, reason);
            })
    }

    public Connect(): void
    {
        this.Log(`Connecting to ${this._config.ServerInfo.Addr}...`);

        this.Socket?.connect();
    }

    public Disconnect()
    {
        this.Log(`Disconnecting from ${this._config.ServerInfo.Addr}...`);

        this.Socket?.disconnect();
    }
}
